<div class="padding flex column ">
	<h4 class="margin-bottom-small">Add products to order</h4>

	<div class="flex center full-width between">
		<b>Products</b>
		<span class="grey">{{ data.warehouse?.description }}</span>
	</div>

	<div class="full-width scrollable flex column bg-light-grey padding-small margin-top-smallest">
		@for (item of data.styles; track item) {
			<div class="flex column">
				<div class="flex center between">{{ item.brand.name }} - {{ item.code }} - {{ item.name }}</div>
				<div class="grey">
					@for (color of item.colors; track color; let last = $last) {
						<div class="flex center">{{ color.name }} {{ color.size?.name }}</div>
					}
				</div>
			</div>
		}
	</div>

	<b class="margin-top-small">Select an order:</b>

	<div class="flex center margin-top-small margin-bottom-small gap">
		<div class="filter-chip mini" [ngClass]="!orderFilters.ids || !orderFilters.ids.length ? '' : 'selected'">
			@if (orderFilters.ids && orderFilters.ids.length) {
				<div class="flex center hover" (click)="openDialogIdsFilter()">
					<b class="margin-right-smallest">Order ID:</b>
					@for (id of orderFilters.ids; track id; let last = $last) {
						{{ id }}
						@if (!last) {
							,
						}
					}
				</div>

				<mat-icon class="hover" (click)="cleanFilter('ids')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openDialogIdsFilter()">
					Order ID
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip mini" [ngClass]="!orderFilters.creationDate ? '' : 'selected'">
			@if (orderFilters.creationDate) {
				<div class="flex center hover" (click)="openCreationDateFilterModal()">
					<b class="margin-right-smallest">Creation Date:</b>

					{{ orderFilters.creationDate.from | date: 'dd-MM-yyyy' }} - {{ orderFilters.creationDate.to | date: 'dd-MM-yyyy' }}
				</div>
				<mat-icon (click)="cleanFilter('creationDate')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openCreationDateFilterModal()">
					Creation Date
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip mini selected">
			<div class="flex center">
				<b class="margin-right-smallest">Warehouse:</b>

				{{ this.data.warehouse?.description }}
				<i class="fa-solid small fa-lock margin-left-smallest"></i>
			</div>
		</div>

		<!-- <div class="filter-chip mini" [ngClass]="!orderFilters.statuses || !orderFilters.statuses.length ? '' : 'selected'">
			@if (orderFilters.statuses && orderFilters.statuses.length) {
				<div class="flex center hover" (click)="openStatusFilterModal()">
					<b class="margin-right-smallest">Status:</b>

					@for (status of orderFilters.statuses; track status; let last = $last) {
						{{ status.name }}
						@if (!last) {
							,
						}
					}
				</div>

				<mat-icon (click)="cleanFilter('statuses')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openStatusFilterModal()">
					Status
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div> -->
	</div>
	<div class="fix-height fix-width">
		@if (orders && orders.items && orders.items.length) {
			<table>
				<tr>
					<th>Order</th>
					<th>Photographer</th>
					<th>Creation Date</th>
					<th>Due Date</th>
					<!-- <th>Completion Date</th> -->
					<th>Status</th>
					<th>Action</th>
				</tr>
				@for (item of orders.items; track item) {
					<tr>
						<td>
							{{ item.id }}
						</td>
						<td>{{ item.photographer.firstName }} {{ item.photographer.lastName }}</td>
						<td>
							{{ item.creationDate | date: 'dd-MM-yyyy' }}
						</td>
						<td>
							{{ item.dueDate | date: 'dd-MM-yyyy' }}
						</td>
						<!-- <td>
							{{ item.completionDate | date: 'dd-MM-yyyy' }}
						</td> -->
						<td>
							@if (item.status.id == orderStatus.Draft) {
								<span class="radius bg-light-grey primary-dark padding-right-smallest padding-left-smallest">Draft</span>
							} @else if (item.status.id == orderStatus.Submitted) {
								<span class="radius bg-primary white padding-right-smallest padding-left-smallest">Submitted</span>
								<span class="margin-left-smallest small nowrap">Waiting for label creation</span>
							} @else if (item.status.id == orderStatus.ReadyForPickup) {
								<span class="radius bg-primary white padding-right-smallest padding-left-smallest">Ready for pickup</span>
								<span class="margin-left-smallest small nowrap">Waiting for photographer shots</span>
							} @else if (item.status.id == orderStatus.ShootCompleted) {
								<span class="radius bg-orange padding-right-smallest padding-left-smallest">Shoot completed</span>
								<span class="margin-left-smallest small nowrap">Waiting for BasicNet approvation</span>
							} @else if (item.status.id == orderStatus.InProgress) {
								<span class="radius bg-orange padding-right-smallest padding-left-smallest">In Progress</span>
							} @else if (item.status.id == orderStatus.Rejected) {
								<span class="radius bg-red white padding-right-smallest padding-left-smallest">Rejected</span>
								<span class="margin-left-smallest small nowrap">Waiting for photographer to fix</span>
							} @else if (item.status.id == orderStatus.Approved) {
								<span class="radius bg-green white padding-right-smallest padding-left-smallest">Approved</span>
							}
						</td>
						<td>
							<span class="flex center hover red" (click)="addToOrder(item)">
								<i class="fa fa-arrow-right margin-right-smallest"></i>
								Add to this order
							</span>
						</td>
					</tr>
				}
			</table>
		}

		@if (orders.items.length == 0 && !loading) {
			<div class="flex center bg-light-grey padding-largest justify-center">
				<div class="flex column center gap">
					<i class="fa fa-search fa-2xl margin-bottom grey"></i>
					<span>No data found</span>
				</div>
			</div>
		}
	</div>

	<bt-paginator [pageNumber]="orders.currentPage" [pageSize]="orders.size" [totalNumber]="orders.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>

	<div class="flex column end margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Close
			</button>
		</div>
	</div>
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
